module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"This category has no filter options.":"Diese Kategorie hat keine Filteroptionen."}}')
  delete Component.options._Ctor
}
